module.exports = __webpack_public_path__ + "media/img/patterns/reticle-frame-dark-24bc729a274ecf6931d6124b02827beb.svg";